import { gql } from "@apollo/client";

export const FETCH_PRODUCT_LINES = gql`
  query FETCH_PRODUCT_LINES($hasActiveProducts: Boolean) {
    productLines(hasActiveProducts: $hasActiveProducts) {
      results {
        id
        name
        slug
        newImages {
          id
          name
          thumb: url(size: "300x300")
          url
          stage
          ordering
          isPrimary
        }
      }
      total
    }
  }
`;

export const SET_PRODUCT_LINE_IMAGE_PRIMARY = gql`
  mutation SET_PRODUCT_LINE_IMAGE_PRIMARY(
    $productLineId: ID!
    $productLineImageId: ID!
    $stage: String!
  ) {
    setProductLineImagePrimary(
      productLineId: $productLineId
      productLineImageId: $productLineImageId
      stage: $stage
    ) {
      productLine {
        id
        newImages {
          id
          name
          thumb: url(size: "300x300")
          stage
          isPrimary
        }
      }
    }
  }
`;

export const SORT_PRODUCT_LINE_IMAGES = gql`
  mutation SORT_PRODUCT_LINE_IMAGES(
    $ordering: [ProductLineImageSortInputType]!
  ) {
    sortProductLineImages(ordering: $ordering) {
      productLine {
        id
        newImages {
          id
          name
          ordering
          thumb: url(size: "300x300")
        }
      }
    }
  }
`;

export const SYNC_PRODUCT_LINE_IMAGES = gql`
  mutation SYNC_PRODUCT_LINE_IMAGES($slug: String) {
    syncProductLineBeautyshots(slug: $slug) {
      productLine {
        id
        newImages {
          id
          name
          ordering
          thumb: url(size: "300x300")
        }
      }
    }
  }
`;
